// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3cQnM","fullView":"styles_fullView__1nqyz"};